import { Navbar } from "@web/components/Navbar";
import { useAppContext } from "@web/route-services/root/AppContext";
import { Preview } from "@web/route-services/studio/Preview";
import { Rules } from "@web/route-services/studio/Rules";
import { AnimatePresence, motion } from "motion/react";
import { FormProvider, UseFormReturn } from "react-hook-form";

/**
 * Base UI structure shared between both create and update routes
 */
export function BaseStudioView({ form, children }: { form: UseFormReturn<any>; children: React.ReactNode }) {
  const { isDesktopScreen } = useAppContext();
  if (isDesktopScreen) {
    return (
      <div className="from-background-gradient via-background to-background text-tx-primary flex h-screen w-screen overflow-hidden bg-gradient-to-b text-sm antialiased lg:text-base">
        <Navbar />
        <AnimatePresence mode="wait">
          <motion.div
            className="flex h-full w-full items-center justify-center"
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.2,
              ease: [0, 0.71, 0.2, 1.01]
            }}
          >
            <div className=" relative flex h-5/6 w-full max-w-[80rem] justify-center ">
              <FormProvider {...form}>
                <div className="scroll-primary rounded-4xl h-full overflow-y-auto">
                  <div className="w-full overflow-hidden rounded-2xl">{children}</div>
                </div>
                <div className="ml-6 flex flex-col space-y-5 ">
                  <Preview />
                  <Rules />
                </div>
              </FormProvider>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    );
  }

  return (
    <>
      <Navbar />
      <AnimatePresence mode="wait">
        <motion.div
          className="flex h-full w-full items-center justify-center"
          initial={{ opacity: 0, scale: 0.98 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: [0, 0.71, 0.2, 1.01]
          }}
        >
          <div className="from-background-gradient via-background to-background relative flex h-fit w-full flex-col items-center justify-center bg-gradient-to-b px-1.5 pb-20 pt-2 antialiased md:pb-0">
            {/* Rules */}
            <Rules />
            <FormProvider {...form}>
              <div className="w-full overflow-hidden rounded-2xl">{children}</div>
              <h1 className="text-tx-primary mt-6 text-lg font-semibold">Preview</h1>
              <div className="w-[232px]">
                <Preview />
              </div>
            </FormProvider>
          </div>
        </motion.div>
      </AnimatePresence>
    </>
  );
}
